import React from 'react';
import {useRef} from 'react';
import * as api from '../../api';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ValidateEventDates } from '../../utils/ValidateEvent';
import Spinner from '../../Plateforme/Atoms/Spinner';
import CustomEditor from '../TextEditor/CustomEditor';

const EditEventAdminPanel = (props) => {

    const navigate = useNavigate();
    const [searchparams] = useSearchParams();
    const title_fr_ref = useRef(null);
    const title_en_ref = useRef(null);
    // const description_fr_ref = useRef(null);
    // const description_en_ref = useRef(null);
    const localisation_ref = useRef(null);
    const main_date_ref = useRef(null);
    const online_date_ref = useRef(null);
    const am_or_pm_ref = useRef(null);
    const inscriptions_start_date_ref = useRef(null);
    const inscriptions_end_date_ref = useRef(null);
    const logo_path_ref = useRef(null);
    const image_path_ref = useRef(null);
    const document_path_ref = useRef(null);
    const popA_checkbox_ref = useRef(null);
    const popB_checkbox_ref = useRef(null);
    const [eventData, setEventData] = React.useState(null)

    const [descFR, setDescFR] = React.useState("")
    const [descEN, setDescEN] = React.useState("")

    React.useEffect(()=>{
        api.getEventById({id: searchparams.get("id")}).then((response) => {
            console.log(response.data)
            setEventData(response.data);

            setDescFR(response.data.description_fr)
            setDescEN(response.data.description_en)
        }).catch((error) => {
            console.log(error);
        });
    },[])

    async function handleUpdate() {
        console.log('trying to update');

        const newEvent = new FormData();
        newEvent.append("id", searchparams.get("id"));
        newEvent.append("title_fr", title_fr_ref.current.value);
        newEvent.append("title_en", title_en_ref.current.value);
        newEvent.append("description_fr", descFR);
        newEvent.append("description_en", descEN);
        // newEvent.append("description_fr", description_fr_ref.current.value);
        // newEvent.append("description_en", description_en_ref.current.value);
        newEvent.append("localisation", localisation_ref.current.value);
        newEvent.append("main_date", main_date_ref.current.value);
        newEvent.append("online_date", online_date_ref.current.value);
        newEvent.append("am_or_pm", am_or_pm_ref.current.value);
        newEvent.append("inscriptions_start_date", inscriptions_start_date_ref.current.value);
        newEvent.append("inscriptions_end_date", inscriptions_end_date_ref.current.value);
        newEvent.append("logo_path", logo_path_ref.current.files[0]);
        newEvent.append("image_path", image_path_ref.current.files[0]);
        newEvent.append("document_path", document_path_ref.current.files[0]);
        newEvent.append("popAopen", popA_checkbox_ref.current.checked);
        newEvent.append("popBopen", popB_checkbox_ref.current.checked);

        if(!ValidateEventDates({main_date:main_date_ref.current.value,online_date:online_date_ref.current.value,inscriptions_start_date:inscriptions_start_date_ref.current.value,inscriptions_end_date:inscriptions_end_date_ref.current.value})){
            alert("Dates invalides")
            return
        }

        api.updateEvent(newEvent).then(res => {
            console.log(res);
            navigate("/admin/events")
        }).catch(err => {
            console.log(err);
            alert("erreur");
        });
    }

    async function handleDelete() {
        if(window.confirm("Supprimer définitivement l'évènement ?")){
            api.deleteEvent({id: searchparams.get("id")}).then(res => {
                console.log(res);
                navigate("/admin/events")
            });
        }
    }

    function invite_link(id, pop) {

        return "https://connectedby.lefrenchdesign.org/join?eid=" + id + "&pop=" + pop 

    }

    function copy_link(link){
         // Get the text field
 

   // Copy the text inside the text field
 
  navigator.clipboard.writeText(link)
//   alert("Lien copié !")


    }

    return (
        <div>
            {eventData ? <>
                <span className='linkbutton' onClick={() => navigate('/admin/events')}>← Retour au panneau d'administration</span><br/>
                <br/>
                <h1 className='centered'>Modifier l'évenement {eventData.title_fr}</h1>
                <br/>
                <h2><span >Type d'évènement : <strong>{eventData.type.toUpperCase()}</strong></span></h2><br/><br/>
                <div className='dualInput'>
                    <label>
                        Nom du speed dating FR :<br/>
                        <input type="text" ref={title_fr_ref} defaultValue={eventData.title_fr}/>
                    </label>
                    <label>
                        Nom du speed dating EN :<br/>
                        <input type="text" ref={title_en_ref} defaultValue={eventData.title_en}/>
                    </label>
                </div>
                Description FR :<br/><br/>
                <CustomEditor 
                    value={descFR}
                    onChange={setDescFR}
                />
                <br/><br/>
                Description EN :<br/><br/>
                <CustomEditor 
                    value={descEN}
                    onChange={setDescEN}
                />
                <br/><br/>
                <label>
                    Localisation :<br/>
                    <input type="text" ref={localisation_ref} defaultValue={eventData.localisation}/>
                </label>
                <br/>
                <div className='dualInput'>
                    <label>
                        Date de l'évenement en physique :<br/>
                        <input type="date" ref={main_date_ref} defaultValue={new Date(eventData.main_date).toISOString().split('T')[0]}/>
                    </label>
                    <label>
                        Date de l'évenement en ligne :<br/>
                        <input type="date" ref={online_date_ref} defaultValue={new Date(eventData.online_date).toISOString().split('T')[0]}/>
                    </label>
                </div>
                <br/>
                <label>
                    Horaires de l'évenement :<br/>
                    <select ref={am_or_pm_ref} defaultValue={eventData.am_or_pm}>
                        <option value="am">Matin</option>
                        <option value="pm">Après-midi</option>
                    </select>
                </label>
                <br/>
                <div className='dualInput'>
                    <label>
                        Date de début des inscriptions :<br/>
                        <input type="date" ref={inscriptions_start_date_ref} defaultValue={new Date(eventData.inscriptions_start_date).toISOString().split('T')[0]}/>
                    </label>
                    <label>
                        Date de fin des inscriptions :<br/>
                        <input type="date" ref={inscriptions_end_date_ref}defaultValue={new Date(eventData.inscriptions_end_date).toISOString().split('T')[0]}/>
                    </label>
                </div>
                <label>
                <h2> Logo :</h2><br/>
                    <img  alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + eventData.logo_path}/>
                </label>
                <br/>
                <label>
                    Mettre à jour le logo :<br/>
                    <input type="file" ref={logo_path_ref} />
                </label>
                <br/>
                <label>
                    <h2>Visuel :</h2><br/>
                    <img  alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + eventData.image_path}/>
                </label>
                <br/>
                <label>
                    Mettre à jour le visuel :<br/>
                    <input type="file" ref={image_path_ref} />
                </label>
                <br/>

                <label>
                    Document à faire signer aux populations B :<br/>
                    {eventData.document_to_sign_path && <a href={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + eventData.document_to_sign_path} target='_blank' >Voir le document actuel</a>}<br/>
                    <input type="file" ref={document_path_ref} />
                </label>

                <div className='dualInput'>
                    <label>
                        <input type='checkbox' ref={popA_checkbox_ref} defaultChecked={eventData.popAopen}/> Inscriptions ouvertes aux populations A
                    </label>
                    <label>
                        <input type='checkbox' ref={popB_checkbox_ref} defaultChecked={eventData.popBopen}/> Inscriptions ouvertes aux populations B
                    </label>
                </div>

                <div className='dualInput buttons_cont'>
                    <button className='dualbuttons' onClick={handleUpdate}>Enregistrer</button>
                    <button className='red_button dualbuttons' onClick={handleDelete}>Supprimer</button>
                </div>
                {/* <h2>Liens d'invitation</h2>
                <br/>
                <span className='thin'>Lien de l'évènement pour <b>les fabricants</b> :</span><br/><br/>
                <div className='dualInput'>
                    <EventLink>{invite_link(eventData._id , "a")}</EventLink><button onClick={ () => copy_link(invite_link(eventData._id , "a"))}>Copier le lien</button>
                </div><br/><br/>
                <span className='thin'>Lien de l'évènement pour <b>les architectes d’intérieur</b> :</span><br/><br/> 
                <div className='dualInput'>
                    <EventLink>{invite_link(eventData._id , "b")}</EventLink><button onClick={ () => copy_link(invite_link(eventData._id , "b"))}>Copier le lien</button>
                </div><br/><br/><br/> */}
                <br/>
                <h2>Lien de prévisualisation :</h2>
                {/* in the form of http://localhost:3000/evenements/learnmore?eid=67590da5499bcc995c210b40 */}
                <br/>
                <Link to={"/evenements/learnmore?eid=" + eventData._id}><p>{"evenements/learnmore?eid=" + eventData._id}</p></Link>
            </>:<Spinner/>}
        </div>
    );
};

export default EditEventAdminPanel;